import pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';

if (pdfFonts && pdfFonts.pdfMake && pdfFonts.pdfMake.vfs) {
    pdfMake.vfs = pdfFonts.pdfMake.vfs;
} else if (pdfFonts) {
    pdfMake.vfs = pdfFonts;
}

class ProformaInvoicePdfForm {
    generate(data, translations = {}) {
        this.t = translations;

        const sections = [this.createHeader(data), { text: '', margin: [0, 10] }, this.createInfoBlock(data)];

        const partList = data?.partList || [];
        const laborList = data?.laborList || [];
        const otherCostList = data?.otherCostList || [];

        if (partList.length > 0) {
            sections.push({ text: '', margin: [0, 8] });
            sections.push(this.createSectionTitle(this.t.partTab || 'Parçalar'));
            sections.push(this.createItemTable(partList));
        }
        if (laborList.length > 0) {
            sections.push({ text: '', margin: [0, 8] });
            sections.push(this.createSectionTitle(this.t.laborTab || 'İşçilikler'));
            sections.push(this.createItemTable(laborList));
        }
        if (otherCostList.length > 0) {
            sections.push({ text: '', margin: [0, 8] });
            sections.push(this.createSectionTitle(this.t.otherCostTab || 'Diğer Maliyetler'));
            sections.push(this.createItemTable(otherCostList));
        }

        sections.push({ text: '', margin: [0, 10] });
        sections.push(this.createTotalsBlock(data));

        const docDefinition = {
            pageSize: 'A4',
            pageOrientation: 'portrait',
            pageMargins: [35, 35, 35, 35],
            content: sections,
            defaultStyle: { font: 'Roboto', fontSize: 9 }
        };

        return pdfMake.createPdf(docDefinition);
    }

    getText(key, fallback = '') {
        return (this.t && this.t[key]) || fallback;
    }

    formatNumber(value) {
        if (value == null) return '-';
        return new Intl.NumberFormat('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
    }

    formatDate(dateString) {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleDateString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' });
    }

    warrantyLabel(type) {
        if (type === 1) return this.t.customerPays || 'Müşteri Öder';
        if (type === 2) return this.t.karsanWarranty || 'Karsan Garanti';
        return '-';
    }

    getKarsanLogoSvg() {
        return `<svg viewBox="0 0 66 17.375" fill="none" xmlns="http://www.w3.org/2000/svg">
            <defs><style>.st1{fill:#f05133}</style></defs>
            <path d="M25.72 17.214v-8.521h1.031v8.521zm2.236 -4.521 3.403 4.521h-1.304l-3.254 -4.509 3.279 -4.012h1.304zm9.328 4.521 -0.807 -2.621h-3.18l-0.82 2.621h-1.031l2.844 -8.521h1.329l2.82 8.521h-1.155Zm-2.373 -7.626 -1.342 4.173h2.645l-1.304 -4.173Zm8.844 7.626c-0.067 -0.141 -0.161 -0.325 -0.285 -0.553q-0.186 -0.342 -0.466 -0.77c-0.186 -0.285 -0.4 -0.596 -0.64 -0.931 -0.24 -0.335 -0.501 -0.685 -0.783 -1.049q-0.249 -0.31 -0.441 -0.422c-0.129 -0.074 -0.296 -0.116 -0.503 -0.124v3.851h-1.018v-8.521h1.987c0.29 0 0.547 0.012 0.77 0.037s0.42 0.062 0.59 0.112 0.319 0.108 0.447 0.174c0.128 0.067 0.242 0.141 0.341 0.223c0.099 0.074 0.199 0.167 0.298 0.279s0.188 0.242 0.267 0.391 0.145 0.317 0.199 0.503c0.054 0.186 0.081 0.391 0.081 0.615 0 0.348 -0.054 0.667 -0.161 0.956 -0.108 0.29 -0.261 0.536 -0.46 0.739 -0.199 0.203 -0.437 0.36 -0.714 0.472 -0.278 0.112 -0.586 0.167 -0.925 0.167h-0.124c0.199 0.166 0.369 0.338 0.509 0.516q0.211 0.267 0.348 0.441c0.074 0.099 0.191 0.263 0.348 0.491 0.157 0.228 0.325 0.474 0.503 0.739s0.354 0.528 0.528 0.789 0.313 0.468 0.416 0.621c0.104 0.154 0.159 0.238 0.167 0.254H43.756Zm-0.224 -6.198c0 -0.282 -0.079 -0.542 -0.236 -0.783 -0.157 -0.24 -0.356 -0.41 -0.596 -0.509 -0.141 -0.058 -0.296 -0.101 -0.466 -0.13s-0.371 -0.043 -0.603 -0.043h-0.981v3.18h0.907c0.381 0 0.691 -0.035 0.931 -0.105q0.36 -0.106 0.609 -0.329c0.141 -0.132 0.248 -0.308 0.323 -0.528s0.112 -0.47 0.112 -0.752m8.198 3.789q0 0.596 -0.304 1.143c-0.203 0.364 -0.495 0.667 -0.876 0.907 -0.282 0.182 -0.572 0.315 -0.869 0.397 -0.298 0.083 -0.646 0.124 -1.043 0.124 -0.513 0 -0.992 -0.062 -1.435 -0.186s-0.876 -0.319 -1.298 -0.584l0.447 -0.795c0.356 0.257 0.718 0.443 1.087 0.559s0.768 0.174 1.199 0.174c0.323 0 0.584 -0.027 0.783 -0.081 0.199 -0.054 0.389 -0.151 0.572 -0.292q0.609 -0.459 0.609 -1.217c0 -0.753 -0.509 -1.283 -1.528 -1.59l-0.857 -0.261c-0.389 -0.116 -0.697 -0.228 -0.925 -0.335s-0.425 -0.248 -0.59 -0.422c-0.356 -0.381 -0.534 -0.844 -0.534 -1.391 0 -0.364 0.066 -0.696 0.199 -0.993q0.199 -0.447 0.559 -0.77c0.24 -0.215 0.53 -0.383 0.869 -0.503s0.716 -0.18 1.13 -0.18q1.354 0 2.571 0.82l-0.447 0.733c-0.207 -0.132 -0.397 -0.244 -0.572 -0.335 -0.174 -0.091 -0.341 -0.166 -0.503 -0.223s-0.323 -0.099 -0.485 -0.124c-0.161 -0.025 -0.333 -0.037 -0.516 -0.037 -0.538 0 -0.956 0.124 -1.255 0.373s-0.447 0.592 -0.447 1.031c0 0.348 0.11 0.625 0.329 0.832 0.22 0.207 0.582 0.394 1.087 0.559l0.981 0.31c0.381 0.116 0.683 0.238 0.906 0.366 0.223 0.129 0.422 0.292 0.596 0.491s0.31 0.433 0.41 0.702c0.099 0.269 0.149 0.536 0.149 0.801m6.272 2.409 -0.807 -2.621h-3.18l-0.82 2.621h-1.031l2.844 -8.521h1.329l2.82 8.521h-1.155Zm-2.372 -7.626 -1.342 4.173h2.645l-1.304 -4.173Zm9.303 7.626 -2.732 -5.217c-0.141 -0.257 -0.269 -0.507 -0.385 -0.752q-0.174 -0.366 -0.304 -0.659c-0.087 -0.195 -0.18 -0.407 -0.279 -0.64 0.025 0.273 0.043 0.522 0.056 0.745 0.012 0.223 0.025 0.474 0.037 0.752s0.019 0.553 0.019 0.826l0.05 4.943h-1.056V8.692h1.18l2.832 5.441c0.108 0.198 0.207 0.402 0.298 0.609 0.091 0.207 0.172 0.394 0.242 0.559 0.07 0.166 0.128 0.304 0.174 0.416 0.045 0.112 0.073 0.18 0.081 0.205 0 -0.008 -0.006 -0.091 -0.019 -0.248 -0.013 -0.157 -0.025 -0.358 -0.037 -0.603 -0.012 -0.244 -0.025 -0.519 -0.037 -0.826 -0.013 -0.306 -0.019 -0.613 -0.019 -0.919l-0.037 -4.633h1.006v8.521h-1.068Z" fill="#76777a"/>
            <path class="st1" d="M0.473 8.597 8.599 0.016H0v17.157h8.582z"/>
            <path class="st1" d="M17.147 0v17.189l-8.559 -8.593z"/>
        </svg>`;
    }

    createHeader(data) {
        return {
            columns: [
                { width: 120, svg: this.getKarsanLogoSvg(), fit: [110, 45] },
                {
                    width: '*',
                    stack: [
                        { text: this.t.pdfTitle || 'Proforma Fatura', fontSize: 16, bold: true, alignment: 'right', color: '#333333' },
                        { text: `${this.t.pdfId || 'No'}: ${data?.id || '-'}`, fontSize: 10, margin: [0, 6, 0, 0], alignment: 'right' },
                        { text: `${this.t.createdDate || 'Tarih'}: ${this.formatDate(data?.createdDate)}`, fontSize: 10, margin: [0, 3, 0, 0], alignment: 'right' },
                        { text: `${this.t.printDate || 'Yazdırma Tarihi'}: ${this.formatDate(new Date().toISOString())}`, fontSize: 9, margin: [0, 3, 0, 0], alignment: 'right', color: '#777777' }
                    ]
                }
            ]
        };
    }

    createInfoBlock(data) {
        const tableLayout = {
            hLineWidth: () => 0.5,
            vLineWidth: () => 0.5,
            hLineColor: () => '#dddddd',
            vLineColor: () => '#dddddd'
        };

        const row = (label, value) => [
            { text: label, bold: true, fillColor: '#f5f5f5', margin: [6, 4, 6, 4] },
            { text: value || '-', margin: [6, 4, 6, 4] }
        ];

        const leftBody = [
            row(this.t.customerNameSurname || 'Müşteri', data?.customerNameSurname),
            row(this.t.phone || 'Telefon', data?.customerPhone),
            row(this.t.chassisNo || 'Şasi No', data?.chassisNo)
        ];

        const rightBody = [
            row(this.t.licensePlate || 'Plaka', data?.licensePlate),
            row(this.t.km || 'KM', data?.km != null ? String(data.km) : '-'),
            row(this.t.createdDate || 'Tarih', this.formatDate(data?.createdDate))
        ];

        return {
            columns: [
                { width: '*', table: { widths: [100, '*'], body: leftBody }, layout: tableLayout },
                { width: 10, text: '' },
                { width: '*', table: { widths: [80, '*'], body: rightBody }, layout: tableLayout }
            ]
        };
    }

    createSectionTitle(title) {
        return {
            text: title,
            fontSize: 10,
            bold: true,
            color: '#ffffff',
            fillColor: '#f05133',
            margin: [0, 0, 0, 0],
            table: { widths: ['*'], body: [[{ text: title, bold: true, color: '#ffffff', margin: [6, 4, 6, 4], fontSize: 10 }]] },
            layout: { hLineWidth: () => 0, vLineWidth: () => 0 }
        };
    }

    createItemTable(items) {
        const headerCell = (text, alignment = 'left') => ({
            text,
            bold: true,
            fillColor: '#555555',
            color: '#ffffff',
            alignment,
            margin: [4, 5, 4, 5],
            fontSize: 8
        });

        const headerRow = [
            headerCell(this.t.itemCode || 'Kod'),
            headerCell(this.t.itemName || 'Adı'),
            headerCell(this.t.description || 'Açıklama'),
            headerCell(this.t.quantity || 'Miktar', 'center'),
            headerCell(this.t.unitPrice || 'Birim Fiyat', 'right'),
            headerCell(this.t.totalPrice || 'Toplam', 'right'),
            headerCell(this.t.warrantyType || 'Garanti', 'center')
        ];

        const dataRows = items.map((item, index) => {
            const fillColor = index % 2 === 0 ? '#ffffff' : '#f9f9f9';
            const cell = (text, alignment = 'left') => ({
                text: text || '-',
                alignment,
                margin: [4, 3, 4, 3],
                fillColor,
                fontSize: 8
            });
            return [
                cell(item.itemCode),
                cell(item.itemName),
                cell(item.description),
                cell(item.quantity != null ? this.formatNumber(item.quantity) : '-', 'center'),
                cell(this.formatNumber(item.price), 'right'),
                cell(this.formatNumber(item.totalPrice), 'right'),
                cell(this.warrantyLabel(item.warrantyType), 'center')
            ];
        });

        return {
            table: {
                headerRows: 1,
                widths: [65, '*', 80, 40, 65, 65, 70],
                body: [headerRow, ...dataRows]
            },
            layout: {
                hLineWidth: (i, node) => (i === 0 || i === 1 || i === node.table.body.length) ? 1 : 0.5,
                vLineWidth: () => 0.5,
                hLineColor: (i) => (i <= 1 ? '#555555' : '#dddddd'),
                vLineColor: () => '#dddddd'
            }
        };
    }

    createTotalsBlock(data) {
        const allItems = [...(data?.partList || []), ...(data?.laborList || []), ...(data?.otherCostList || [])];
        const itemsSubtotal = allItems.reduce((sum, i) => sum + Number(i.totalPrice || 0), 0);

        const row = (label, value, highlight = false) => ({
            columns: [
                { width: '*', text: '' },
                {
                    width: 280,
                    table: {
                        widths: ['*', 120],
                        body: [[
                            { text: label, bold: highlight, fillColor: highlight ? '#f5f5f5' : '#ffffff', margin: [6, 3, 6, 3] },
                            { text: value, alignment: 'right', bold: highlight, fillColor: highlight ? '#f5f5f5' : '#ffffff', margin: [6, 3, 6, 3] }
                        ]]
                    },
                    layout: { hLineWidth: () => 0.5, vLineWidth: () => 0.5, hLineColor: () => '#dddddd', vLineColor: () => '#dddddd' }
                }
            ]
        });

        return {
            stack: [
                row(this.t.itemsSubtotal || 'Kalemler Ara Toplamı', this.formatNumber(itemsSubtotal)),
                { text: '', margin: [0, 2] },
                row(this.t.totalPrice || 'Toplam (KDV Dahil)', this.formatNumber(data?.totalPrice)),
                { text: '', margin: [0, 2] },
                row(this.t.discountPrice || 'İndirim', this.formatNumber(data?.discountPrice)),
                { text: '', margin: [0, 2] },
                row(this.t.netPrice || 'Net Tutar', this.formatNumber(data?.netPrice), true)
            ]
        };
    }
}

export default ProformaInvoicePdfForm;
